import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAuthStore from "./states/useAuth"; // Adjust import based on your store structure
import ApproverLayout from "./components/Approver/Layout";
import MerchantUserLayout from "./components/MerchantUser/Layout";
import log from "./utils/log";

const PrivateRoute = ({ component: Component, hasLayout, allowedRoles, ...rest }) => {
  const { auth } = useAuthStore(); // Assuming auth contains the user's role
  // log.debug(auth.role);

  if (!auth.passed) {
    // Not authenticated
    return <Redirect to="/login" />;
  }

  // Check if user's role is allowed to access the route
  if (allowedRoles && !allowedRoles.includes(auth.role)) {
    return <Redirect to="/error/403" />; // Redirect to unauthorized page or handle accordingly
  }

  const Layout = auth.role === "merchantUser" ? MerchantUserLayout : ApproverLayout;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (hasLayout && Layout) {
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
